import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { HelperService } from 'app/shared/services/helper.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigureInformationService {
  sidebarItemDataEmiter: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient, private helperService: HelperService) { }

  getConfigureInformationList(type: string, data: DataTableStateModel): Observable<any> {
    data = this.helperService.replaceFilterBlanksSelection(data);

    let baseUrl = '/v1/dropdown-configurations/search';

    let params: any = {
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC ? true : false,
      orderField: data.sortingValue.prop ? data.sortingValue.prop : undefined,
      fieldFilters: data.datatableFilters || []
    };

    return this.http.post(`${baseUrl}?type=${type}`, params);
  }

  saveConfigureInformation(params: any): Observable<any> {
    let url = this.http.post('/v1/dropdown-configurations', params);

    if (params.id) {
      url = this.http.put(`/v1/dropdown-configurations`, params);
    }

    return url;
  }

  deleteConfigureInformation(id: number): Observable<any> {
    let url = '/v1/dropdown-configurations';

    return this.http.delete(`${url}/${id}`);
  }

}
